/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Style_HelpInputs */

const en_caption_style_help = /** @type {(inputs: Caption_Style_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the display style for captions`)
};

const fr_caption_style_help = /** @type {(inputs: Caption_Style_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez le style d’affichage des sous-titres`)
};

const de_caption_style_help = /** @type {(inputs: Caption_Style_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie den Darstellungsstil für Untertitel aus.`)
};

const it_caption_style_help = /** @type {(inputs: Caption_Style_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona lo stile di visualizzazione per le didascalie`)
};

const ru_caption_style_help = /** @type {(inputs: Caption_Style_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите стиль отображения для подписей.`)
};

const es_caption_style_help = /** @type {(inputs: Caption_Style_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el estilo de visualización para los subtítulos`)
};

const zh_cn2_caption_style_help = /** @type {(inputs: Caption_Style_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择字幕的显示样式`)
};

const ja_caption_style_help = /** @type {(inputs: Caption_Style_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションの表示スタイルを選択する`)
};

const hi_caption_style_help = /** @type {(inputs: Caption_Style_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन के लिए डिस्प्ले स्टाइल चुनें`)
};

const pt_pt2_caption_style_help = /** @type {(inputs: Caption_Style_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o estilo de exibição para as legendas.`)
};

/**
* | output |
* | --- |
* | "Select the display style for captions" |
*
* @param {Caption_Style_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style_help = /** @type {((inputs?: Caption_Style_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Style_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_caption_style_help(inputs)
	if (locale === "de") return de_caption_style_help(inputs)
	if (locale === "it") return it_caption_style_help(inputs)
	if (locale === "ru") return ru_caption_style_help(inputs)
	if (locale === "es") return es_caption_style_help(inputs)
	if (locale === "zh-CN") return zh_cn2_caption_style_help(inputs)
	if (locale === "ja") return ja_caption_style_help(inputs)
	if (locale === "hi") return hi_caption_style_help(inputs)
	if (locale === "pt-PT") return pt_pt2_caption_style_help(inputs)
	return en_caption_style_help(inputs)
});